import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * Возвращает информацию о локации по IP-адресу
 * https://master.r1-platform-gateway.sandbox.d2c.r-one.io/docs#/Geo/Ip2cityContoller_cityByIp
 * @param ip IP-адрес для проверки
 */
export const cityByIp = (ip: string): IRequest => {
    return {
        uri: `/v1/city-by-ip/${ip}`,
        method: 'GET',
    };
};
